import { useState } from 'react';
import { orderBy } from 'es-toolkit';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { PostListHorizontal } from './post-list-horizontal';
import { PostItemSkeleton } from './post-skeleton';

// ----------------------------------------------------------------------

export function PostListHomeView({
  posts,
  loading,
  isSuperAdmin,
  onEdit,
  onDelete,
  tags,
  categories,
  page,
  totalPages,
  onPageChange,
  unwatchedVideos,
  ...other
}) {
  const [sortBy, setSortBy] = useState('latest');
  const dataFiltered = applyFilter({ inputData: posts, sortBy });

  return (
    <Container maxWidth="xl">
      <Box
        sx={[
          () => ({
            gap: 3,
            display: 'flex',
            mb: { xs: 3, md: 5 },
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-end', sm: 'center' },
            maxWidth: '100%',
          }),
        ]}
      ></Box>
      {dataFiltered.length ? (
        <PostListHorizontal
          posts={dataFiltered}
          loading={loading}
          isSuperAdmin={isSuperAdmin}
          onEdit={onEdit}
          onDelete={onDelete}
          tags={tags}
          categories={categories}
          page={page}
          totalPages={totalPages}
          onPageChange={onPageChange}
          other={other}
          unwatchedVideos={unwatchedVideos}
        />
      ) : !loading ? (
        <Typography>Nothing to show</Typography>
      ) : (
        <PostItemSkeleton itemCount={other.limit} />
      )}
    </Container>
  );
}

// ----------------------------------------------------------------------

function applyFilter({ inputData, sortBy }) {
  if (sortBy === 'latest') {
    return orderBy(inputData, ['createdAt'], ['desc']);
  }

  if (sortBy === 'oldest') {
    return orderBy(inputData, ['createdAt'], ['asc']);
  }

  if (sortBy === 'popular') {
    return orderBy(inputData, ['totalViews'], ['desc']);
  }

  return inputData;
}
